// extracted by mini-css-extract-plugin
export var container = "_48-0";
export var disabled = "_48-4";
export var fullWidth = "_48-3";
export var lined = "_48-1";
export var selected = "_48-5";
export var tab = "_48-2";